module.exports = __webpack_public_path__ + "img/Coffea_arabica.ab117567.jpg";